import appModule from '../../app.module'
import { ILocationService, IScope } from 'angular'

function NavigationService($location: ILocationService, $rootScope: IScope, $stateParams: any, $state: any) {
  const setHash = (hash: string) => {
    $location.hash(hash)
    $rootScope.$apply()
  }

  const setLocation = (path: string) => {
    $location.path(path)
    $rootScope.$apply()
  }

  const setPath = (path: string) => {
    $location.path(path)
    $rootScope.$apply()
  }

  const setUrl = (url: string) => {
    $location.url(url)
    $rootScope.$apply()
  }

  return {
    get hash() {
      return $location.hash()
    },
    setHash,

    setLocation,

    get path() {
      return $location.path()
    },
    setPath,

    get url() {
      return $location.url()
    },
    setUrl: setUrl,

    routeParams: $stateParams,
    state: $state
  }
}

appModule.service('navigationService', ['$location', '$rootScope', '$stateParams', '$state', NavigationService])

export type NavigationService = ReturnType<typeof NavigationService>
